import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';

/**
 * Angular built-in pipes are not provided in root by default — they belong to CommonModule
 * and are only available in the component injector tree. Several root-level services
 * (e.g. report and analysis services) inject these pipes directly in their constructors,
 * so they must be explicitly provided here and registered in AppModule to make them
 * available application-wide.
 */
export const PIPE_PROVIDERS = [CurrencyPipe, DatePipe, DecimalPipe];
